export function normalizeString(value) {
  return String(value ?? '').trim().toLowerCase();
}

export function getByPath(row, path) {
  if (!row || !path) return '';
  const parts = String(path).split('.');
  let cur = row;
  for (const key of parts) {
    if (cur == null) return '';
    cur = cur[key];
  }
  return cur ?? '';
}

export function applyGlobalSearch(rows, search, fields) {
  const q = normalizeString(search);
  if (!q) return rows;
  const f = Array.isArray(fields) ? fields : [];
  return (rows || []).filter((row) => {
    if (!f.length) {
      return normalizeString(JSON.stringify(row)).includes(q);
    }
    const hay = f.map((key) => normalizeString(getByPath(row, key))).join(' ');
    return hay.includes(q);
  });
}

export function applyColumnFilters(rows, filters, definitions) {
  const list = rows || [];
  const defs = definitions || [];
  const active = filters || {};
  return list.filter((row) => {
    for (const def of defs) {
      const key = def.key;
      const mode = def.type || 'text';
      const value = active[key];
      const raw = getByPath(row, def.field || key);
      if (mode === 'multi') {
        const selected = Array.isArray(value) ? value.map((v) => String(v)) : [];
        if (selected.length && !selected.includes(String(raw ?? ''))) return false;
      } else if (mode === 'date') {
        const rowDate = String(raw || '').slice(0, 10);
        const from = String(value?.from || '');
        const to = String(value?.to || '');
        if (from && rowDate && rowDate < from) return false;
        if (to && rowDate && rowDate > to) return false;
      } else {
        const q = normalizeString(value);
        if (q && !normalizeString(raw).includes(q)) return false;
      }
    }
    return true;
  });
}

export function runTableFilters(rows, draft, applied, globalSearchFields, columnDefs) {
  const global = applyGlobalSearch(rows, applied?.globalSearch, globalSearchFields);
  return applyColumnFilters(global, applied?.columns, columnDefs);
}

export function buildMultiOptionsFromRows(rows, field, mapLabel) {
  const out = [];
  const seen = new Set();
  for (const row of rows || []) {
    const raw = getByPath(row, field);
    const value = String(raw ?? '').trim();
    if (!value || seen.has(value)) continue;
    seen.add(value);
    out.push({
      value,
      label: typeof mapLabel === 'function' ? mapLabel(value, row) : value
    });
  }
  return out;
}

/** Max rows to load when client-side column/header filters are active (pagination is applied after filter). */
export const CLIENT_SIDE_TABLE_FILTER_FETCH_LIMIT = 10000;

/**
 * True when table header search or any column filter is active, so filtering must run on a full dataset
 * rather than only the current server page.
 */
export function hasActiveClientTableFilters(applied, columnDefs) {
  // Unified table filter dropdowns must be built from the full in-scope dataset
  // (not only current server page rows), so force client filtering mode whenever
  // a table has unified column definitions.
  if (Array.isArray(columnDefs) && columnDefs.length > 0) return true;
  if (String(applied?.globalSearch || '').trim()) return true;
  const cols = applied?.columns || {};
  const defs = columnDefs || [];
  for (const def of defs) {
    const key = def.key;
    const mode = def.type || 'text';
    const value = cols[key];
    if (mode === 'multi') {
      if (Array.isArray(value) && value.length > 0) return true;
    } else if (mode === 'date') {
      if (String(value?.from || '').trim() || String(value?.to || '').trim()) return true;
    } else if (String(value ?? '').trim()) {
      return true;
    }
  }
  return false;
}

